import { Box, Drawer } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { logo } from "../../assets";
import NavSection from "../../components/NavSection";
import { useContentSetting } from "../../Hooks/ContentSetting";
import sidebarConfig from "./SidebarConfig";
import { SIDEBAR_WIDTH } from "../../utils/layoutUtils";

export default function AppSidebar({
  drawerWidth,
  handleDrawerToggle,
  mobileOpen,
}) {
  const { userInfo } = useContentSetting();

  const paperSx = {
    boxSizing: "border-box",
    border: "none",
    overflowX: "hidden",
  };

  const drawer = (
    <div className="sidebar-shell">
      <div className="sidebar-shell__brand">
        <RouterLink to="/dashboard" className="sidebar-shell__brand-link">
          <img
            src={logo}
            alt="XS Learnix Admin"
            className="app-logo sidebar-shell__logo"
            decoding="async"
          />
          <div className="sidebar-shell__brand-text">
            <span className="sidebar-shell__brand-name">XS Learnix Admin</span>
            <span className="sidebar-shell__brand-tag">Admin Panel</span>
          </div>
        </RouterLink>
      </div>
      <NavSection navConfig={sidebarConfig(userInfo)} />
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label="Dashboard navigation"
      className="app-sidebar-box"
    >
      <Drawer
        variant="temporary"
        className="sidebar-temporary-drawer"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            ...paperSx,
            width: drawerWidth || SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        className="sidebar-permanent-drawer"
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            ...paperSx,
            width: SIDEBAR_WIDTH,
            marginLeft: `${drawerWidth === 0 ? `-${SIDEBAR_WIDTH}` : "0"}px`,
          },
        }}
        open={Boolean(drawerWidth)}
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
